import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useConfiguration, Text } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import { HotelCategory } from '../../../components/HotelCategory/index.js';
import { Container } from '../../../components/HotelDescription/TourOperatorInformation/components/Container.js';
import { Flex } from '../../../primitives/Flex/index.js';
export const TourOperatorInformation = ({
  hotelData,
  tourOperatorData
}) => {
  const {
    t
  } = useTranslation('hotelDescription');
  const brandName = useConfiguration('brandName');
  if (!tourOperatorData ||
  // No name at all should never happen (makes no sense),
  // but if it does, there's no point in showing the component
  !tourOperatorData.hotelName) {
    return null;
  }
  const differences = {
    hotelName: hotelData.name !== tourOperatorData.hotelName,
    hotelCategory: hotelData.category !== tourOperatorData.hotelCategory,
    hotelCategoryType: hotelData.categoryType !== tourOperatorData.hotelCategoryType
  };
  if (!differences.hotelName && !differences.hotelCategory && !differences.hotelCategoryType) {
    // at least one difference required
    return null;
  }
  return _jsxs(Container, {
    gap: "4px",
    children: [_jsx(Text, {
      preset: "paragraphSmall",
      children: t('nameAndStarsDifferent')
    }), _jsxs(Flex, {
      direction: "row",
      gap: "4px",
      children: [_jsx(Text, {
        preset: "paragraphSmallBold",
        children: `${tourOperatorData.tourOperatorName}:`
      }), _jsx(Text, {
        preset: "paragraphSmall",
        children: tourOperatorData.hotelName
      }), _jsx(HotelCategory, {
        type: tourOperatorData.hotelCategoryType,
        value: tourOperatorData.hotelCategory,
        withTooltip: true
      })]
    }), _jsxs(Flex, {
      direction: "row",
      gap: "4px",
      children: [_jsx(Text, {
        preset: "paragraphSmallBold",
        children: `${brandName}:`
      }), _jsx(Text, {
        preset: "paragraphSmall",
        children: hotelData.name
      }), _jsx(HotelCategory, {
        type: hotelData.categoryType,
        value: hotelData.category,
        withTooltip: true
      })]
    })]
  });
};